import { apiRequest } from "./api-client";
import type { VisitStatus } from "./types";
import { ApiError } from "./api-client";

export enum ELoginProviders {
  Email = 1,
  Sms = 2,
  Google = 10,
}

export interface LoginResponse {
  id: string;
  providerId: ELoginProviders;
  providerName: string;
  providerKey: string;
  disabledOn: string | null;
}

export interface UserWithLoginsResponse {
  userId: string;
  username: string;
  email: string | null;
  phoneNumber: string | null;
  logins: LoginResponse[];
}

export class AccountLoginsApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  try {
    return await apiRequest<T>(path, init);
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new AccountLoginsApiError(error instanceof ApiError ? error.status : 500, message);
  }
}

export async function getTenantLogins(): Promise<UserWithLoginsResponse[]> {
  return request<UserWithLoginsResponse[]>("/account-logins");
}

export async function changeLoginPassword(loginId: string, newPassword: string): Promise<void> {
  await request<void>(`/account-logins/${loginId}/password`, {
    method: "PUT",
    body: JSON.stringify({ newPassword }),
  });
}


